export default __webpack_public_path__ + "static/media/clip.38d33985.svg";